import formFieldComponent from './form-field.component';

const formFieldModule = angular.module('formField', [
])
  .component('formField', formFieldComponent)
  .name;

export default formFieldModule;
